import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import { isSectionNameUnique } from './addNewSection';
import type { TranslationName } from 'types/translator';

export interface Payload {
  value: {
    collapsed: boolean;
    name: string;
    newName: string;
    title: TranslationName[];
    description?: string;
    tabId?: string | null;
  };
  layoutType: LayoutType;
}

export const renameSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { value, layoutType } = payload;
  const sections = state[layoutType].sections;

  if (value.newName !== value.name && !isSectionNameUnique(sections, value.newName ?? '')) {
    throw new Error('exists');
  }

  const sectionIndex = sections.findIndex((section) => section.name === value.name);

  if (sectionIndex !== -1) {
    state[layoutType].sections[sectionIndex].name = value.newName;
    state[layoutType].sections[sectionIndex].title = value.title;
    state[layoutType].sections[sectionIndex].collapsed = value.collapsed;
    if (value.description !== undefined) {
      state[layoutType].sections[sectionIndex].description = value.description;
    }
    if (value.tabId !== undefined) {
      state[layoutType].sections[sectionIndex].tabId = value.tabId;
    }
  }
};
